var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarginbottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_5966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.722168 0.339844V16.0898H1.65967V14.9648H2.59717V16.0898H3.53467V14.9648H4.47217V16.0898H5.40967V14.9648H6.34717V16.0898H7.28467V14.9648H8.22217V16.0898H9.15967V14.9648H10.0972V16.0898H11.0347V14.9648H11.9722V16.0898H12.9097V14.9648H13.8472V16.0898H14.7847V14.9648H15.7222V0.339844H0.722168ZM14.7847 13.8398H1.65967V1.46484H14.7847V13.8398ZM0.722168 17.2148H1.65967V18.3398H0.722168V17.2148ZM1.65967 16.0898H2.59717V17.2148H1.65967V16.0898ZM2.59717 17.2148H3.53467V18.3398H2.59717V17.2148ZM3.53467 16.0898H4.47217V17.2148H3.53467V16.0898ZM4.47217 17.2148H5.40967V18.3398H4.47217V17.2148ZM5.40967 16.0898H6.34717V17.2148H5.40967V16.0898ZM6.34717 17.2148H7.28467V18.3398H6.34717V17.2148ZM7.28467 16.0898H8.22217V17.2148H7.28467V16.0898ZM8.22217 17.2148H9.15967V18.3398H8.22217V17.2148ZM9.15967 16.0898H10.0972V17.2148H9.15967V16.0898ZM10.0972 17.2148H11.0347V18.3398H10.0972V17.2148ZM11.0347 16.0898H11.9722V17.2148H11.0347V16.0898ZM11.9722 17.2148H12.9097V18.3398H11.9722V17.2148ZM12.9097 16.0898H13.8472V17.2148H12.9097V16.0898ZM13.8472 17.2148H14.7847V18.3398H13.8472V17.2148ZM14.7847 16.0898H15.7222V17.2148H14.7847V16.0898Z",
    fill: "#A4A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_5966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "white",
    transform: "translate(0.722168 0.339844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginbottom);
export default __webpack_public_path__ + "static/media/marginbottom.2df1d2f8abbdd23891a9769131cbcc82.svg";
export { ForwardRef as ReactComponent };